/*
 * ELONI: varukorgsnotisen ska bekräfta - inte avbryta.
 * Ändrat mot Dawns original:
 *  - ingen focus trap och ingen .focus() (notisen stal fokus och kastade upp
 *    kunden till headern mitt i att hen scrollade bland produkter)
 *  - notisen stänger sig själv efter 4 sekunder
 *  - nedräkningen pausas om kunden rör eller fokuserar notisen, så att
 *    "Visa varukorg" och "Kassan" hinner klickas
 */
class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.autoCloseDelay = 4000;
    this.autoCloseTimeout = null;

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );

    this.notification.addEventListener('mouseenter', this.clearAutoClose.bind(this));
    this.notification.addEventListener('focusin', this.clearAutoClose.bind(this));
    this.notification.addEventListener('touchstart', this.clearAutoClose.bind(this), { passive: true });
    this.notification.addEventListener('mouseleave', this.scheduleAutoClose.bind(this));
  }

  open() {
    this.notification.classList.add('animate', 'active');

    document.body.addEventListener('click', this.onBodyClick);
    this.scheduleAutoClose();
  }

  scheduleAutoClose() {
    this.clearAutoClose();
    this.autoCloseTimeout = setTimeout(this.close.bind(this), this.autoCloseDelay);
  }

  clearAutoClose() {
    if (this.autoCloseTimeout) {
      clearTimeout(this.autoCloseTimeout);
      this.autoCloseTimeout = null;
    }
  }

  close() {
    this.clearAutoClose();
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    this.getSectionsToRender().forEach((section) => {
      document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
        parsedState.sections[section.id],
        section.selector
      );
    });

    if (this.header) this.header.reveal();
    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
